import makeApiCall from "./axiosIndex";
const labourMasterApis = {
  labourTypesList: async (): Promise<any> => {
    return makeApiCall({
      url: "/masters/laborTypesList",
      method: "get",
    });
  },

  fetchLabourWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchLaborCategoriesWithPagination",
      method: "get",
      params,
    });
  },

  fetchLabourDropDown: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchLaborCategoryDropDown",
      method: "get",
    });
  },

  fetchLabourById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchLaborCategoryById`,
      method: "get",
      params: { id },
    });
  },

  updateLabourById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateLaborCategoryById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createLabour: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createLaborCategory`,
      method: "post",
      data,
    });
  },

  deleteLabourById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteLaborCategoryById",
      method: "delete",
      params: { id },
    });
  },

  // status
  allowActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/activateLaborCategoryById`,
      params: { id },
    }),

  removeActiveStatus: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/inActivateLaborCategoryById`,
      params: { id },
    }),
};

export default labourMasterApis;
